<div #canvasContainer id="ManipDraggableContainer">
    <canvas #canvas class="ManipDraggableCanvas"></canvas>
    <ng-content></ng-content>
</div>